'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var LifeExpectancyTable = require('../tables/lifeExpectancyTable');
		}
}

var Expectancy = function(expectancies) {
	this.lifeExpectancyTable = new LifeExpectancyTable(expectancies);
};


Expectancy.prototype.expectancy = function(gender, currentAge) {
	return this.lifeExpectancyTable.getExpectancy(gender, currentAge);
};


//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = Expectancy;
    }
    exports.Expectancy = Expectancy;
}
